import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgFuriousSelectedEmojiSecondary from './svgs/FuriousSelectedEmojiSecondary.js';
import SvgFuriousSelectedEmoji from './svgs/FuriousSelectedEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var furiousSelectedEmoji = (props => useIcon(SvgFuriousSelectedEmoji, SvgFuriousSelectedEmojiSecondary, props));

export { furiousSelectedEmoji as default };
